var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchiveLine = function SvgArchiveLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.4 10.2h-.9V4.803c0-.499.41-.903.893-.903h16.214a.89.89 0 0 1 .893.903V10.2h-.9v9.001a.896.896 0 0 1-.894.9H5.294a.897.897 0 0 1-.894-.9v-9Zm14.4 0H6.2v8.1h12.6zM5.3 5.7v2.7h14.4V5.7zM9.8 12h5.4v1.8H9.8z"
  })));
};
export default SvgArchiveLine;